import { gtagEventProps } from "@definitions/types"
import { isDevEnvironment } from "@utils/utils"

export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID!
export const GADS_TRACKING_ID = process.env.NEXT_PUBLIC_GADS_TRACKING_ID!

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const gtagPageView = (url: string) => {
  if (isDevEnvironment) return
  window.gtag?.("config", GA_TRACKING_ID, {
    page_path: url,
  })
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const gtagEvent = ({
  action,
  category,
  label,
  value,
}: gtagEventProps) => {
  if (isDevEnvironment) return
  window.gtag?.("event", action, {
    event_category: category,
    event_label: label,
    value: value,
  })
}
